import Accordion from 'react-bootstrap/Accordion';
import addNewOrder from '../assets/addNewOrder.jpg';
import notesAttachments from '../assets/notesAttachments.jpg';
import notes from '../assets/notes.jpg';
import cancelOrder from '../assets/cancelOrder.jpg';
import orderStatus from '../assets/orderStatus.jpg';
import orderStatus2 from '../assets/orderStatus2.png';

const Help = () => {
    return (
        <div className="page">
            
            <div className="page-header page-header-sticky"> 
                <div className="page-header-title">
                    <h1>Help & FAQ</h1>
                </div>
            </div>
        
            <Accordion>
                <Accordion.Item eventKey="0" className="faq-group">
                    <Accordion.Header as="div"><h4>How do I submit a new Order for a new case?</h4></Accordion.Header>
                    <Accordion.Body className="faq-answer">
                        <p>1. Locate the teal <strong>+ Add New Order</strong>, available on both your <strong>Dashboard</strong> and the <strong>Order Details</strong> screen.</p>
                        <p>2. Click this button and you will be redirected to the <strong>Order Intake</strong> process.</p>
                        <img src={addNewOrder} />
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>

            <Accordion>
                <Accordion.Item eventKey="1" className="faq-group">
                    <Accordion.Header as="div"><h4>How can I add additional documents or attachments after an Order has already been submitted?</h4> </Accordion.Header>
                    <Accordion.Body className="faq-answer">
                        <p>1. Navigate to the <strong>Order Details</strong> screen by selecting the specific Order from your <strong>Dashboard</strong>. </p>
                        <p>2. Scroll down to the <strong>Attachments</strong> section </p>
                        <p>3. Click the teal <strong>+ Add New</strong> button and follow the prompts to either add a new note or attachment! </p>
                        <img src={notesAttachments} />
                    </Accordion.Body>
                </Accordion.Item>                
            </Accordion>

            <Accordion>
                <Accordion.Item eventKey="2" className="faq-group">
                    <Accordion.Header as="div"><h4>How can I view notes pertaining to my Order? </h4></Accordion.Header>
                    <Accordion.Body className="faq-answer">
                        <p>1. Navigate to the <strong>Order Details</strong> screen by selecting the specific Order from your <strong>Dashboard</strong>. </p>
                        <p>2. Scroll down to the <strong>Notes</strong> section </p>
                        <p>3. Click the underlined message to open a pop-up with the note details. </p>
                        <img src={notes} />
                    </Accordion.Body>
                </Accordion.Item>                
            </Accordion>


            <Accordion>
                <Accordion.Item eventKey="3" className="faq-group">
                    <Accordion.Header as="div"><h4>How do I request to cancel an Order?</h4> </Accordion.Header>
                    <Accordion.Body className="faq-answer">
                        <p>1. From you <strong>Dashboard</strong>, select the Order(s) you wish to cancel.</p>
                        <p>2. Click  <strong>Choose an Actions</strong> and select the <strong>Cancel Order Request</strong> from the dropdown menu. </p>
                        <p>3. A pop-up will appear asking for the reason of cancellation. Enter the required information and click Confirm Cancellation to submit your request. </p>
                        <img src={cancelOrder} />
                    </Accordion.Body>
                </Accordion.Item>                
            </Accordion>

            <Accordion>
                <Accordion.Item eventKey="4" className="faq-group">
                    <Accordion.Header as="div"><h4>How can I view the results of my Order?</h4> </Accordion.Header>
                    <Accordion.Body className="faq-answer">
                        <p>1. Navigate to the <strong>Order Details</strong> screen by selecting the specific Order from your <strong>Dashboard</strong>. </p>
                        <p>2. Under the Attachments Section, you will find a downloadable PDF Labeled "Investigation Results". </p>
                        <p>3. Click on the file name to download the PDF to your device and view your results! </p>
                        <p>Please note that Investigation Results will only be made available once your Order has been marked as Complete. You can view your Order's status at any time by checking under the Status column on your Dashboard or by looking for the Status field in your General Information on the Order Details screen! </p>
                        <img src={orderStatus} />
                        <img src={orderStatus2} />
                    </Accordion.Body>
                </Accordion.Item>                
            </Accordion>

            <Accordion>
                <Accordion.Item eventKey="5" className="faq-group">
                    <Accordion.Header as="div"><h4>How can I add a new Order to an existing Case?</h4></Accordion.Header>
                    <Accordion.Body className="faq-answer">
                        <p>1. To submit a new order to an existing case, simply locate the teal + Add New Order button, available on both your Dashboard and the Order Details screen. Clicking this button will take you directly to the Order Intake process. </p>
                        <img src={addNewOrder} />
                    </Accordion.Body>
                </Accordion.Item>                
            </Accordion>

    </div>
    );
}

export default Help;